/* eslint-disable */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../../supabase';
import { usePortalPermissions } from '../../../hooks/usePortalPermissions';

export function useQcRole() {
  // PERM-P5: a super-admin is always a QC manager, matching DB get_my_qc_role()
  // (PERM-P4). Uses the reactive isSuperAdmin flag — the app's canonical read
  // path — fixing the old isSuperAdmin() no-arg call that always returned false
  // and silently rendered super-admins as inspector.
  const { data: pp } = usePortalPermissions();
  const isSuper = !!pp?.isSuperAdmin;

  const { data: qcRole, isLoading } = useQuery({
    queryKey: ['qcRole', isSuper],
    queryFn: async () => {
      if (isSuper) return 'manager';
      const { data, error } = await supabase.rpc('get_my_qc_role');
      if (error) return 'inspector';
      return data || 'inspector';
    },
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 1,
  });

  const role = isSuper ? 'manager' : (qcRole || 'inspector');

  return {
    qcRole: role,
    isManager: role === 'manager',
    isInspector: role === 'inspector',
    loading: isLoading,
  };
}
